import { createContext } from 'react'
import { OurStory, Parties, TheResturant } from './Announcements'

export const AppData = createContext(null)
export const AppDispatch = createContext(null)

export function appReducer(state, action) {
	switch (action.type) {
		case 'picture': return { ...state, picture: action.value }
		case 'gallery': return { ...state, gallery: action.value }
		case 'announcement': return { ...state, announcement: state.announcements[action.value] }
		default: throw Error('Unexpected action', action)
	}
}

export const initialState = {
	picture: null,
	gallery: null,
	galleries: {
		castello: {
			data: await fetch('./uploads/Castello/data.json').then(response => response.json()),
			path: 'uploads/Castello'
		},
		food: {
			data: await fetch('./uploads/Food/data.json').then(response => response.json()),
			path: 'uploads/Food'
		},
		staff: {
			data: await fetch('./uploads/Staff/data.json').then(response => response.json()),
			path: 'uploads/Staff'
		},
		parties: {
			data: await fetch('./uploads/Parties/data.json').then(response => response.json()),
			path: 'uploads/Parties'
		}
	},
	announcement: null,
	announcements: {
		'our-story': OurStory,
		'the-restaurant': TheResturant,
		'parties': Parties
	}
}
